module.exports = __webpack_public_path__ + "img/website-store-tiles-01-3_low_calendars.225f58be.jpeg";